import type { UserProfile } from '../../application/dto/dtos';

/**
 * Entite User FrontEnd (legere)
 * Orientee affichage et verification de roles.
 * Ne contient PAS de logique serveur (hachage, verrouillage BD, etc.)
 */
export class User {
  private constructor(
    public readonly id: string,
    public readonly email: string,
    public readonly nom: string,
    public readonly prenom: string,
    public readonly role: string,
    public readonly isActive: boolean,
    public readonly emailVerifie: boolean,
    public readonly deuxFacteursActive: boolean,
    public readonly deuxFacteursMethode: 'EMAIL' | 'APPLICATION' | undefined,
    public readonly dateCreation: Date,
    public readonly derniereMiseAJour: Date | undefined,
    public readonly lastPasswordChange: Date | undefined,
  ) {}

  /**
   * Factory : cree un User a partir du DTO UserProfile
   */
  static fromProfile(profile: UserProfile): User {
    return new User(
      profile.id,
      profile.email,
      profile.nom ?? '',
      profile.prenom ?? '',
      profile.role,
      profile.isActive,
      profile.emailVerifie,
      profile.deuxFacteursActive,
      profile.deuxFacteursMethode,
      profile.dateCreation,
      profile.derniereMiseAJour,
      profile.lastPasswordChange,
    );
  }

  /**
   * Factory : cree un User minimal a partir des donnees de login
   */
  static fromLoginResult(data: {
    idUtilisateur: string;
    email: string;
    nom: string;
    prenom?: string;
    role: string;
  }): User {
    return new User(
      data.idUtilisateur,
      data.email,
      data.nom,
      data.prenom ?? '',
      data.role,
      true,
      true,
      false,
      undefined,
      new Date(),
      undefined,
      undefined,
    );
  }

  estAdministrateur(): boolean {
    return this.role.toUpperCase().includes('ADMIN');
  }

  aRole(role: string): boolean {
    return this.role === role;
  }

  getNomComplet(): string {
    return `${this.prenom} ${this.nom}`.trim();
  }

  a2FAActif(): boolean {
    return this.deuxFacteursActive;
  }

  /**
   * Convertit l'entite vers le DTO UserProfile (pour le store)
   */
  toProfile(): UserProfile {
    return {
      id: this.id,
      email: this.email,
      nom: this.nom,
      prenom: this.prenom,
      role: this.role,
      isActive: this.isActive,
      emailVerifie: this.emailVerifie,
      deuxFacteursActive: this.deuxFacteursActive,
      deuxFacteursMethode: this.deuxFacteursMethode,
      dateCreation: this.dateCreation,
      derniereMiseAJour: this.derniereMiseAJour,
      lastPasswordChange: this.lastPasswordChange,
    };
  }
}
